<template>
    <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100vh;">
      <v-img
        :src="background"
        height="100%"
        style="opacity: 0.9;"
        class="bg-login"
      >
        <div
          style="
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(to top right, rgba(100, 115, 201, 0.4), rgba(25, 32, 72, 0.7));
            -webkit-background: -webkit-linear-gradient(to top right, rgba(100, 115, 201, 0.4), rgba(25, 32, 72, 0.7));
          "
        />
      </v-img>
    </div>
  </template>
  
  <script>
import { BACKGROUND_LIST } from '@/utils/utils';

  export default {
    props: {
      gradientBG: {
        type: String,
        default: () => "to top right, rgba(100,115,201,.40), rgba(25,32,72,.7)"
      }
    },
    data () {
      return {
        background: 'img/background-login.jpg',
        logo: process.env.VUE_APP_LOGO_BRANCA ? process.env.VUE_APP_LOGO_BRANCA : 'img/brcorte5-logo.png'
      }
    },
    created () {
      let backgrounds = BACKGROUND_LIST
      this.background = backgrounds[parseInt((Math.random() * 100)) % backgrounds.length]
    }
  }
  </script>
  